<template>
  <template v-if="selectRemove">
    <template v-if="info.status === 'edit'">
      <select-remote
          :title="info.title"
          :widget="selectRemove"
          v-model="data[propName]"
      />
    </template>
    <template v-else>
      <morph-table :data="data" v-bind="$props"/>
    </template>
  </template>
</template>

<script lang="ts" setup>
import {computed, defineProps, watch} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import SelectRemote from "@/components/business/crud/common/SelectRemote.vue";
import {MorphFieldType} from "@/components/business/crud/interface/FieldType";
import MorphTable from "@/components/business/crud/widgets/impl/MorphTable.vue";

const props = defineProps<{
  propName: string;
  widget: MorphFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();
const modelName = computed(() => data.value[props.widget.modelNameProp])
watch(modelName, () => {
  data.value[props.propName] = null;
});

const selectRemove = computed(() => {
  if (!modelName.value) {
    return null;
  }
  const model = props.widget.models[modelName.value];
  if (!model) {
    return null;
  }
  return {
    name: 'selectRemote',
    multi: false,
    path: model.basePath + '/index',
    createPagePath: model.basePath + '/create',
    viewPagePath: model.basePath + '/view',
    labelFieldName: model.labelPropName || "name",
    valueFieldName: 'id'
  }
})
</script>

<style lang="scss" scoped>
.notfound {
  display: flex;
  flex-direction: row;
  //justify-content: center;
  align-items: center;
  height: 60px;
}
</style>
